<script>
import { RouterLink } from "vue-router";

import { addPackageAndLangParams } from "@/common/route-path-helpers";

export default {
  name: "TheBreadcrumbs",
  components: {
    RouterLink
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addPackageAndLangParams
  }
};
</script>

<template>
  <nav class="breadcrumbs" aria-label="breadcrumbs">
    <ol class="breadcrumbs__list">
      <li v-for="(item, index) in items" :key="index" class="breadcrumbs__item">
        <RouterLink
          v-if="item.route"
          :to="addPackageAndLangParams({ name: item.route })"
          class="breadcrumbs__link"
          active-class="breadcrumbs__link--current"
        >
          {{ item.text }}
        </RouterLink>
        <template v-else>
          {{ item.text }}
        </template>
      </li>
    </ol>
  </nav>
</template>
